import doItLaterMethods from './Parent.doItLater'

export const DoItLaterServices = {
  ...doItLaterMethods
}
